import { h } from 'preact';
import dlv from 'dlv';
import { Text } from 'preact-i18n';

import style from './style';

import ResponsiveHorizontalCard from '../../../cards/responsive-horizontal-card';

import { SadlibAd } from '../../../pieces/sadlib-ad';
import { TopBar } from '../../../pieces/topbar';

import { Column, Row, ContainerFluid } from '@cube/layout';
import { Button } from '@cube/blocks';
import { TrackingProvider, DIMENSION } from '@cube/track';
import { MobileHeader } from '@cube/header-widget';

export const Phone = ({ pageConfig, categoryConfig, hasAssets, assets, error, hasMore, showMore, ...props }) =>
	(
		<div class={style.phone}>
			<MobileHeader
				{...props}
				{...pageConfig.header}
			/>
			<TopBar
				type={dlv(categoryConfig, 'topbar')}
			/>
			<ContainerFluid>
				<Row class={style.contentRow} key="contentRow">
					<Column>
						<Row>
							<Column class={style.categoryHeader}>
								<div class={style.title}>
									{categoryConfig.title}
								</div>
							</Column>
						</Row>
						{ hasAssets &&
							<Row>
								{ assets.map((asset, i) => (
									[
										(
											pageConfig.adPlacements && pageConfig.adPlacements.indexOf(i) >= 0 &&
												<SadlibAd id={`sc_browse_banner${pageConfig.adPlacements.indexOf(i)+1}`} type="phoneSquare" />
										),
										<TrackingProvider {...{ [DIMENSION.clickindex]: i }}>
											<ResponsiveHorizontalCard
												asset={asset}
												imageRole="w=300,h=169"
												imageCategory={categoryConfig.imageCategory}
												cardClass={style.rhCard}
												qeId={'browse-' + i}
												{...props}
											/>
										</TrackingProvider>
									]
								)) }
							</Row>
						}
						{
							!hasAssets && error &&
							<Column>
								<Row>
									<div class={style.errorMessage}>
										<Text id="noArticles" />
									</div>
								</Row>
							</Column>
						}
						{ hasMore &&
							<Row>
								<Button onClick={showMore}>
									<Text id="showMore" />
								</Button>
							</Row>
						}
					</Column>
				</Row>
				<SadlibAd id="adhesion" />
			</ContainerFluid>
		</div>
	);
